export const HTML_ID_EDITOR_OVERLAY = 'editor-overlay';

export const NON_BINDABLE_CONTROL_TYPES = ['GridColumns'];
